import { getSupabaseClient } from "../../providers/supabase/supabase";

/** is_dnc_any rechaza más de 50 valores por llamada. */
const DNC_BATCH = 50;

/** true si alguno de los teléfonos o correos está en No contactar (la lista no se lee, solo sí/no). */
export const isDncAny = async (values: string[]): Promise<boolean> => {
  const sb = getSupabaseClient();
  for (let i = 0; i < values.length; i += DNC_BATCH) {
    const { data, error } = await sb.rpc("is_dnc_any", {
      p_values: values.slice(i, i + DNC_BATCH),
    });
    if (error) throw error;
    if (data === true) return true;
  }
  return false;
};

/** Agrega un valor a No contactar. true si era nuevo, false si ya estaba. */
export const dncAdd = async (
  value: string,
  kind: string,
  reason: string,
): Promise<boolean> => {
  const { data, error } = await getSupabaseClient().rpc("dnc_add", {
    p_value: value,
    p_kind: kind,
    p_reason: reason,
  });
  if (error) throw error;
  return data === true;
};
